const buildRequest = (endPoint, queryParams) => {
  const queryString = Object.entries(queryParams).reduce((acc, [key, value], ind, arr) => {
    const suffix = ind < arr.length - 1 ? '&' : '';
    return `${acc}${key}=${value}${suffix}`;
  }, '');
  return `${endPoint}?${queryString}`;
};

export { buildRequest };
